export default function() {
  let ctrl = function($window, $cookies, $stateParams, surveyService, dialogService, $timeout, $sce) {
    "ngInject";

    const _ = require("underscore")._;
    const moment = require("moment");

    const vm = this;

    const languages = surveyService.getLanguageKeys();

    vm.lang = languages.indexOf($stateParams.lang) == -1 ? "eng" : $stateParams.lang;

    vm.getLanguageSpecificContent = function(object) {
      return object ? (object[vm.lang] ? object[vm.lang] : object["eng"]) : "";
    };

    vm.submitting = false;
    vm.ready = false;
    vm.alreadyTaken = false;
    vm.noSurvey = false;
    vm.useGlobalPassword = false;

    //survey password flags
    vm.usePassword = false;
    vm.enteredPassword = '';
    vm.authenticating = false;
    vm.autherror = false;
    vm.loginsuccess = false;
    vm.trustedHtml = (plainText) => $sce.trustAsHtml(plainText);
    vm.getLoginPageContent = (content) => vm.trustedHtml(vm.getLanguageSpecificContent(content));

    if (surveyService.getSurvey().title) {
      document.title = vm.getLanguageSpecificContent(surveyService.getSurvey().title);
      vm.title = surveyService.getSurvey().title;
      vm.sections = surveyService.getSurvey().sections;
      vm.inviteCodeMetadata = surveyService.getMetadata();

      vm.showLandingPage = surveyService.getSurvey().showLandingPage;
      vm.landingPageContent = surveyService.getSurvey().landingPageContent;
      vm.languageSelector = surveyService.getSurvey().languageSelector;

      if (vm.inviteCodeMetadata) {
        surveyService.viewedSurvey();
        if (vm.inviteCodeMetadata.status === "COMPLETED") {
          vm.alreadyTaken = true;
        } else {
          vm.ready = true; //survey is ready once loaded for an invite link
        }
      } else {
        //survey is only ready if we aren't using a password set up state to show password form
        vm.usePassword = surveyService.getSurvey().usePassword;
        vm.useGlobalPassword = surveyService.getSurvey().useGlobalPassword;
        vm.ready = !vm.usePassword && !vm.showLandingPage;
      }
    } else {
      vm.noSurvey = true;
    }

    // GA Begin
    (function(i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");

    ga("create", "UA-52754256-1", "auto");
    ga("send", "pageview");
    const surveySystem = surveyService.getSurvey().system;
    const surveyFacility = surveyService.getSurvey().facility;
    ga("send", "event", `${surveySystem}-${surveyFacility}`, "survey_load", "");
    // GA End

    $timeout(function() {
      const mobiscroll = require("../../mobiscroll/mobiscroll.custom-3.0.1.min.js");
      mobiscroll.calendar(".mobiscroll-date-input", {
        dateFormat: "yyyy/mm/dd",
        buttons: [],
        onDayChange(event, inst) {
          inst.select();
        },
      });
    });

    vm.changeLang = function(lang) {
      if (vm.inviteCodeMetadata) {
        window.location = `${window.location.pathname}?i=${vm.inviteCodeMetadata.inviteCode}&lang=${lang}`;
      } else {
        window.location = `${window.location.pathname}?lang=${lang}`
      }
    }

    vm.login = function() {
      //don't allow empty passwords
      if (vm.enteredPassword.trim().length === 0) return;

      //show spinnger while authenticating
      vm.authenticating = true;
      vm.autherror = false;

      surveyService.login(vm.enteredPassword, vm.useGlobalPassword).then( (res) => {
        //res is true/false for login success
        vm.authenticating = res; //continue "authenticating" to show spinner on a good login to show spinner while redirecting
        vm.autherror = !res; //show auth error if we have one
        vm.loginsuccess = res; //for additional animation
      });
    }

    vm.reload = () => {
      window.location = window.location;
    }

    vm.getSaveError = () => {
      return surveyService.getSaveError();
    }

    vm.closeError = () => {
      surveyService.clearSaveError();
    }

    vm.toggleGridAnswer = function(sectionId, questionId, optionId) {
      surveyService.toggleGridAnswer(sectionId, questionId, optionId);
    };

    vm.toggleAnswer = function(sectionId, optionId) {
      surveyService.toggleAnswer(sectionId, optionId);
    };

    vm.toggleCheck = function(sectionId, optionId) {
      surveyService.toggleCheck(sectionId, optionId);
    }

    vm.selectAnswer = function(event, sectionId, optionId) {
      if (typeof event !== "undefined") {
        event.stopPropagation();
      }
      surveyService.selectAnswer(sectionId, optionId);
    };

    vm.isConditionalMet = function(section) {
      return surveyService.isConditionalMet(section);
    };

    vm.getTitle = function(object) {
      return vm.getLanguageSpecificContent(surveyService.getTitle(object));
    };

    vm.isGrid = function(sectionType) {
      return /^.*_GRID$/.test(sectionType);
    };

    vm.submit = function() {
      vm.submitting = true;

      const surveyLoad = surveyService.getGuid();
      const cookieName = `srh_survey_load_${surveyService.getSurvey().id}`;
      const oldCookie = $cookies.getObject(cookieName);
      let cookie = [];
      if (oldCookie) {
        cookie = oldCookie;
      }
      cookie.push(surveyLoad);

      const data = {
        surveyLoad,
        cookie,
        inviteCode: $stateParams.i,
        inviteCodeMetadata: vm.inviteCodeMetadata,
        surveyResponseCount: cookie.length,
        languageCompletedIn: vm.lang,
        surveyId: surveyService.getSurvey().id,
        surveyKey: $stateParams.surveyKey,
        surveyTitle: surveyService.getSurvey().title,
        results: [],
      };

      let unit = "";

      for (let i = 0; i < vm.sections.length; i++) {
        const section = vm.sections[i];
        if (section.type === "TEXT") {
          continue;
        }
        const result = {
          section: {
            id: section.id,
            type: section.type,
            title: section.title,
          },
        };
        if (
          section.required &&
          surveyService.isConditionalMet(section) &&
          (!section.answer || (!section.answer.optionId && !section.answer.inputValue))
        ) {
          vm.submitting = false;
          vm.showRequired = true;
          document.getElementById(section.id).scrollIntoView({ behavior: "smooth" });
          return;
        }
        if (section.answer == null) {
          section.answer = {
            optionId: null,
            inputValue: "",
          };
        }
        if (/^.*_GRID$/.test(section.type)) {
          result.questions = [];
          for (let j = 0; j < section.questions.length; j++) {
            const sectionQuestion = section.questions[j];
            if (sectionQuestion.answer == null) {
              sectionQuestion.answer = { optionId: null };
            }
            const id = typeof sectionQuestion.answer.optionId === "undefined" ? null : sectionQuestion.answer.optionId;
            let value = null;
            let optionIndex = null;
            let userInput;
            if (sectionQuestion.input) {
              userInput = sectionQuestion.answer.inputValue;
            }
            for (let k = 0; k < section.options.length; k++) {
              const option = section.options[k];
              if (option.id == id) {
                value = option.value.eng;
                optionIndex = k;
              }
            }
            let question = {
              id: sectionQuestion.id,
              title: sectionQuestion.title,
              userInput: sectionQuestion.input,
              answer: { id, value, optionIndex, userInput },
              column: sectionQuestion.column,
            };
            result.questions.push(question);
          }
        } else {
          result.column = section.column;
          if (section.type === "MULTIPLE_CHOICE") {
            const id = typeof section.answer.optionId === "undefined" ? null : section.answer.optionId;
            let value = null;
            let userInput;
            for (let j in section.options) {
              const option = section.options[j];
              if (option.input) {
                result.section.userInput = true;
              }
              if (option.id == id) {
                if (!option.input) {
                  value = option.value.eng;
                  if (section.column === "unit") {
                    unit = value;
                  }
                } else {
                  value = section.answer.inputValue == null ? "" : section.answer.inputValue;
                  userInput = true;
                }
              }
            }
            result.answer = { id, value, userInput };
          } else if (section.type === "CHECKBOX_LIST") {
            result.answers = section.options.filter(o => o.checked);
          } else {
            const value = section.answer.inputValue == null ? "" : section.answer.inputValue;
            result.answer = { value };
          }
        }
        data.results.push(result);
      }

      let attemptCount = 0;

      const redirect = function(response) {
        const requestTime = new Date().getTime() - startTime;
        ga(
          "send",
          "timing",
          `${surveySystem}-${surveyFacility}`,
          `survey_submit${attemptCount ? "_" + (attemptCount + 1).toString() : ""}`,
          requestTime,
          ""
        );
        $cookies.putObject(cookieName, cookie, {
          path: "/",
          expires: moment()
            .add(10, "years")
            .toDate(),
        });
        $window.location.href = response.data.url;
      };

      const tryAgain = function(res) {
        setTimeout(() => {
          const resCopy = angular.copy(res);
          delete resCopy.config.data.results;
          delete resCopy.config.data.cookie;
          resCopy.headers = resCopy.headers();
          resCopy.config.data.unit = unit;
          throw new Error("Failed to submit survey: " + JSON.stringify(resCopy));
        });
        const requestTime = new Date().getTime() - startTime;
        ga(
          "send",
          "timing",
          `${surveySystem}-${surveyFacility}`,
          `survey_submit_error${attemptCount ? "_" + (attemptCount + 1).toString() : ""}`,
          requestTime,
          ""
        );
        ga(
          "send",
          "event",
          `${surveySystem}-${surveyFacility}`,
          `survey_submit_error${attemptCount ? "_" + (attemptCount + 1).toString() : ""}`,
          ""
        );
        attemptCount += 1;
        if (attemptCount < 3) {
          setTimeout(() => {
            surveyService.recordSurveyResponse(data).then(redirect, tryAgain);
          }, 1000);
        } else {
          vm.submitting = false;
          setTimeout(() => {
            dialogService.open("Failed to save survey response. Please try again.", "Error", null, "Dismiss");
          }, 250);
        }
      };

      const startTime = new Date().getTime();
      surveyService.recordSurveyResponse(data).then(redirect, tryAgain);

      ga("send", "event", `${surveySystem}-${surveyFacility}`, "survey_submit", unit);
    };
  };

  const radioButton = `
        <li ng-click="survey.toggleAnswer(section.id, option.id)">
            <div class="radio-button" 
                 ng-class="{active: section.answer.optionId === option.id}">
                <div class="radio-button-center"></div>
            </div> 
            <span class="radio-button-label" ng-bind="survey.getLanguageSpecificContent(option.value)"></span>
            <input ng-if="option.input" 
                   placeholder="Type here" 
                   ng-model="section.answer.inputValue" 
                   ng-click="survey.selectAnswer($event, section.id, option.id)" 
                   ng-change="survey.selectAnswer($event, section.id, option.id)"
                   ng-keypress="survey.saveSurveyProgress()">
        </li>`;

  const checkButton = `
    <li>
        <div class="check-button" ng-class="{active: option.checked}">
          <div class="surveycheck">
            <input type="checkbox" id="checkbox{{::$id}}" ng-model="option.checked" ng-change="survey.toggleCheck()">
            <label for="checkbox{{::$id}}" ng-bind="survey.getLanguageSpecificContent(option.value)"></label>
          </div>
        </div> 
    </li>`;

  const radioQuestion = `
        <div class="radio-question">
            <div class="row no-gutter">
                <div class="col-sm-12" 
                     ng-if="section.options.length <= 8">
                    <ul>
                        <div ng-repeat="option in section.options">
                            ${radioButton}
                        </div>
                    </ul>
                </div>
                <div class="col-sm-6" ng-if="section.options.length > 8">
                    <ul>
                        <div ng-repeat="option in section.options" ng-if="$index < section.options.length / 2">
                            ${radioButton}
                        </div>
                    </ul>
                </div>
                <div class="col-sm-6" ng-if="section.options.length > 8">
                    <ul>
                        <div ng-repeat="option in section.options" ng-if="$index >= section.options.length / 2"">
                            ${radioButton}
                        </div>
                    </ul>
                </div>
            </div>
        </div>`;

  const checkboxQuestion = `
    <div class="checklist-question">
      <div class="row no-gutter">
          <div class="col-sm-12" 
              ng-if="section.options.length <= 8">
              <ul>
                  <div ng-repeat="option in section.options">
                      ${checkButton}
                  </div>
              </ul>
          </div>
          <div class="col-sm-6" ng-if="section.options.length > 8">
              <ul>
                  <div ng-repeat="option in section.options" ng-if="$index < section.options.length / 2">
                      ${checkButton}
                  </div>
              </ul>
          </div>
          <div class="col-sm-6" ng-if="section.options.length > 8">
              <ul>
                  <div ng-repeat="option in section.options" ng-if="$index >= section.options.length / 2"">
                      ${checkButton}
                  </div>
              </ul>
          </div>
      </div>
    </div>`

  const radioGrid = `
        <table class="radio-grid"
               ng-class="{na8: section.options.length === 7, na7: section.options.length === 6, na6: section.options.length === 5, white: (section.type === 'EFFECTIVE_5_GRID' || section.type === 'RATE_5_GRID')}">
            <thead>
                <tr class="odd">
                    <th></th>
                    <th ng-repeat="option in section.options"><span ng-bind="survey.getLanguageSpecificContent(option.value)"></span></th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="question in section.questions" ng-if="survey.getTitle(question)">
                    <th><span ng-bind-html="survey.getTitle(question)"></span><input ng-if="question.input" placeholder="Type here" ng-model="question.answer.inputValue" ng-keypress="survey.saveSurveyProgress()"></td>
                    <th ng-repeat="option in section.options"
                        ng-click="survey.toggleGridAnswer(section.id, question.id, option.id)"
                        class="radio-grid-button"
                        data-label="{{survey.getLanguageSpecificContent(option.value)}}">
                        <div class="radio-button" 
                             ng-class="{active: question.answer.optionId === option.id}">
                            <div class="radio-button-center"></div>
                        </div> 
                    </th>
                </tr>
            </tbody>
        </table>`;

  const freeTextQuestion = `
        <textarea placeholder="Type here" ng-model="section.answer.inputValue" ng-keypress="survey.saveSurveyProgress()"></textarea>
    `;

  const freeInputQuestion = `
        <input class="survey-input" placeholder="Type here" ng-model="section.answer.inputValue" ng-keypress="survey.saveSurveyProgress()">
    `;

  const datePicker = `
        <input class="survey-input mobiscroll-date-input" placeholder="YYYY/MM/DD" ng-model="section.answer.inputValue">
    `;

  const template = `
        <div id="reload-error" class="reload-error" ng-class="{active: survey.getSaveError()}">
          <h3>Get Latest Survey Progress?</h3>
          <p>Reload your browser to restore your most recent survey progress.</p>
          <button ng-click="survey.reload()">Reload</button>
          &nbsp;&nbsp;
          <a href="#" ng-click="survey.closeError()">close</a>
        </div>
        <div id="saving-message" class="saving-message">Progress Saved</div>
        <div class="survey-header">
            <a href="http://safeandreliablecare.com" target="_blank">
                <img src="/logo.svg">
            </a>
        </div>
        <div ng-show="survey.ready">
            <div class="survey-body">
              <div id="language-selector" ng-if="survey.languageSelector">
                <a href="#" ng-repeat="lang in survey.languageSelector track by $index" ng-bind="lang[1]" ng-click="survey.changeLang(lang[0])"></a>
              </div>

              <h1 ng-bind-html="survey.getLanguageSpecificContent(survey.title)"></h1>
                  <div id="{{section.id}}"
                     ng-repeat="section in survey.sections track by $index"
                     ng-if="survey.isConditionalMet(section) && survey.getTitle(section)">
                    <h2 style="white-space: normal" ng-class="{'show-required': (section.required && survey.showRequired && (!section.answer || (!section.answer.optionId && !section.answer.inputValue)))}">
                        <span ng-bind-html="survey.trustedHtml(survey.getTitle(section))" style="white-space: pre-line"></span>
                        <span ng-if="section.required" style="color: red">*</span>
                        <span ng-if="section.required && survey.showRequired && (!section.answer || (!section.answer.optionId && !section.answer.inputValue))" style="color: red">(Required)</span>
                    </h2>
                    <div ng-if="section.type === 'MULTIPLE_CHOICE'">
                        ${radioQuestion}
                    </div>
                    <div ng-if="section.type === 'CHECKBOX_LIST'">
                        ${checkboxQuestion}
                    </div>
                    <div ng-if="survey.isGrid(section.type)">
                        ${radioGrid}
                    </div>
                    <div ng-if="section.type === 'FREE_TEXT'">
                        ${freeTextQuestion}
                    </div>
                    <div ng-if="section.type === 'FREE_INPUT'" class="survey-input__parent">
                        ${freeInputQuestion}
                    </div>
                    <div ng-if="section.type === 'DATE'" class="survey-input__parent">
                        ${datePicker}
                    </div>
                </div>
                <button class="large" style="margin-top: 40px" ng-click="survey.submit()" ng-bind="survey.lang === 'spa' ? 'Enviar' : 'Submit'"></button>
            </div>
            <div class="loader-overlay row-custom" ng-class="{'show-loader': survey.submitting}">
                <div class="col-float-vert">
                    <div class="loader-text row-custom">
                        <div class="col-float-vert">
                            <div class="loader" style="margin: 20px auto"></div>
                            <div>submitting your answers</div>
                            <div>please wait...</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ng-show="survey.alreadyTaken">
            <div class="survey-body" style="text-align: center">
                <h1 ng-bind-html="survey.getLanguageSpecificContent(survey.title)"></h1>
                <div class="fade-in" style="background: #2980b9; border-radius: 50%; width: 140px; height: 140px; margin: 40px auto"></div>
                <i ng-cloak class="material-icons" style="color: #fff; font-size: 80px; cursor: default; position: relative; top: -150px; display: block; height: 0">thumb_up</i>
                <p>You have already taken this survey.</p>
            </div>
        </div>
        <div ng-show="survey.noSurvey">
            <div class="survey-body" style="text-align: center">
                <div class="fade-in" style="background: #fff; border-radius: 50%; width: 140px; height: 140px; margin: 40px auto 0 auto"></div>
                <i ng-cloak class="material-icons" style="color: #969ead; font-size: 160px; cursor: default; position: relative; top: -150px; display: block; height: 0">error</i>
                <h1 style="margin: 30px 0 20px 0"> Survey not found </h1>
                <p> The survey you are looking for is closed or the url is incorrect. </p>
            </div>
        </div>
        <div ng-show="survey.showLandingPage">
          <div class="survey-body" style="text-align: center">
            <h1 ng-bind-html="survey.getLanguageSpecificContent(survey.title)"></h1>
            <div ng-bind-html="survey.trustedHtml(survey.getLanguageSpecificContent(survey.landingPageContent))"></div>
          </div>
        </div>
        <div ng-show="survey.usePassword">
          <form
            <div class="survey-body" style="text-align: center" ng-class="{'login-success': survey.loginsuccess}">
                <h1 class="login-title">
                  <span class="login-title-default" ng-bind="survey.getLanguageSpecificContent(survey.title)"></span>
                  <span class="login-title-success">Accessing Your Survey</span>
                </h1>
                <div class="login-layout">
                  <div class="login-left">
                    <p>For <strong>physicians and providers</strong>, your passcode is your NPI number.</p>
                    <p>For <strong>colleagues</strong>, your passcode is a random code unique to you.</p>
                  </div>
                  <div class="login-right">
                    <h4>Please enter your passcode</h4>
                    <div class="login-form" ng-if="!survey.authenticating">
                        <input type="password" class="login-password" placeholder="Type here" ng-model="survey.enteredPassword" autocomplete="nope" ng-focus="true">
                        <p ng-if="survey.autherror" class="error">Invalid password</p>
                        <button ng-click="survey.login()" ng-bind="survey.lang === 'spa' ? 'Enviar' : 'Submit'"></button>
                    </div>
                    <div ng-if="survey.authenticating" class="loader" style="margin: 20px auto"></div>
                  </div>
                </div>
                <div class="login-footer">
                  If you do not know your code that can be obtained from your local ministry survey lead. You may also look up your code with your email and employee ID by by clicking <a href="https://trinity.safeandreliablecare.com/lookup.html">here</a>.
                </div>
                
                
            </div>
        </div>
    `;

  return {
    restrict: "E",
    scope: {
      saved: "=",
    },
    template: template,
    controller: ctrl,
    controllerAs: "survey",
  };
}



// WEBPACK FOOTER //
// ./app/components/survey/survey.directive.js